<cmn-layout>
    <div header-left>
        <a class="logo" routerLink="/">
            <img src="../assets/logo.png" alt="WAGAS - Handlowcy">
            <span class="logo-title">Sales Support System</span>
        </a>
    </div>
    <div header-right>
        <cmn-menu initialState="expanded">

            <cmn-menu-item name="Moje dokumenty" link="/moja-biblioteka" icon="documents-white" class="mobile"></cmn-menu-item>
            <cmn-menu-item name="Książka adresowa" link="/kontakty" icon="book-white" class="mobile"></cmn-menu-item>

            <cmn-menu-item name="Moje aplikacje mobilne"
                           icon="phone"
                           *ngIf="mobileManagerAuthCheckUrl"
                           (click)="onMobileAppsClick($event)"
            ></cmn-menu-item>
            <cmn-menu-item name="Moje dokumenty" link="/moja-biblioteka" icon="documents"></cmn-menu-item>
            <cmn-menu-item name="Książka adresowa" link="/kontakty" icon="book"></cmn-menu-item>
            <cmn-menu-item name="Stwórz wysyłkę" link="/stworz-wysylke" activePattern="stworz-wysylke" icon="send"></cmn-menu-item>

        </cmn-menu>
        <cmn-user-box ></cmn-user-box>

    </div>

    <ng-template #footerContent>
        <p><b>Helpdesk:</b></p>
        <p>WAGAS S.A.</p>
        <div>tel: 22 635 61 29</div>
        <div>e-mail: <a href="mailto:office@wagas.pl">office@wagas.pl</a></div>
    </ng-template>
    <footer footer [ngClass]="{'hidden': layoutService.isFooterDisabled()}">
        <ng-container *ngTemplateOutlet="footerContent"></ng-container>
    </footer>
    <footer login-footer>
        <ng-container *ngTemplateOutlet="footerContent"></ng-container>
    </footer>

</cmn-layout>
<div class="dialog">
    <ng-container #container>

    </ng-container>
</div>
